/**
 * DevExtreme (esm/exporter/jspdf/export_gantt.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
function exportGantt(options) {
    var component = options.component;
    return null === component || void 0 === component ? void 0 : component.exportToPdf(options)
}
export {
    exportGantt
};
